import "./style.css"
import React, { useEffect, useMemo, useState } from "react"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import PuffLoading from "components/Loading/PuffLoading"
import { Col, Row } from "reactstrap"
import { useLazyQuery, useMutation } from "@apollo/client"
import PaginatedTable from "components/Table/PaginatedTable"
import DropshipSelectionTable from "components/Table/DropshipSelectionTable"
import ShipmentTable from "components/Table/ShipmentTable"
import DropshipTable from "components/Table/DropshipTable"
import OvalLoading from "components/Loading/OvalLoading"
import { GET_ORDER_PRODUCTS_BY_ID } from "graphql/queries/orders"
import {
  ADD_ORDER_NOTES,
  SEND_ORDER_EMAIL,
  UPDATE_ORDER_PRODUCT_STATUS,
} from "graphql/mutations/order"
import { CREATE_SHIPMENT, CREATE_RETURN_SHIPMENT, GET_RETURN_SHIPMENTS_BY_ORDER_ID, RETRY_SHIPMENT_CSV } from "graphql/mutations/shipment"
import { PRINT_LABELS } from "graphql/mutations/label"
import useCustomMutation from "graphql/hooks/useCustomMutation"
import { toast } from "react-toastify"
import _ from "lodash"
import { GET_ALL_DELIVERY_PARTNERS } from "graphql/queries/partner"
import { DELIVERY_TIMES } from "utils/deliveryTimes"
import { CREATE_LABELS } from "graphql/mutations/labelPrinting"
import { useParams, useNavigate } from "react-router-dom"
import { LINKS } from "utils/links"
import ShipmentLoader from "components/Common/ShipmentLoader"
import ConfirmationDialog from "components/Common/ConfirmationDialog"
import PrintLabelModel from "components/Common/PrintLabelModel"
import ExistingShipmentsTable from "components/Table/ExistingShipmentsTable"
import ReturnShipmentTable from "components/Table/ReturnShipmentTable"
import ExistingDropshipsTable from "components/Table/ExistingDropshipsTable"
import ShipmentConfirmationForDusselDrop from "components/Common/ShipmentConfirmation/DusselDrop"
import ShipmentConfirmationForLogique from "components/Common/ShipmentConfirmation/Logique"
import ShipmentConfirmationForDPD from "components/Common/ShipmentConfirmation/Dpd"
import ShipmentConfirmationForDPDPickup from "components/Common/ShipmentConfirmation/DpdPickup"
import ShipmentConfirmationForMaxpakket from "components/Common/ShipmentConfirmation/Maxpakket"
import { PARTNERS, SHIPMENT_SUPPLIER, shippingColors } from "utils/constants"
import { formatDate, getPickupAndDeliveryDays } from "utils/generator"

const ORDER_STATUS = ["processing", "picked", "completed"]

function OrderProcessing() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [orderId, setOrderId] = useState("")
  const [orderNotes, setOrderNotes] = useState("")
  const [orderData, setOrderData] = useState()
  const [customerData, setCustomerData] = useState([])
  const [groupedData, setGroupedData] = useState({})
  const [deliveryPartnersData, setDeliveryPartnersData] = useState([])
  const [labels, setLabels] = useState([])

  const [updateStatus] = useCustomMutation(UPDATE_ORDER_PRODUCT_STATUS)
  const [addOrderNotes] = useMutation(ADD_ORDER_NOTES)
  const [addShipment] = useMutation(CREATE_SHIPMENT)
  const [createReturnShipment, { loading: createReturnShipmentLoading }] = useMutation(CREATE_RETURN_SHIPMENT)
  const [printLabel] = useMutation(PRINT_LABELS)
  const [sendEmail, { loading: sendEmailLoading }] =
    useCustomMutation(SEND_ORDER_EMAIL)
  const [createLabel, { loading: labelLoading }] = useMutation(CREATE_LABELS)
  const [retryShipmentCSVMutation, { loading: retryShipmentLoading }] = useMutation(RETRY_SHIPMENT_CSV)
  const [shipment, setShipment] = useState([])
  const [dropship, setDropship] = useState([])
  const [selectedId, setSelectedId] = useState([])
  const [selectedDropshipProductId, setSelectedDropshipProductId] = useState([])
  const [moveSelectedData, setmoveSelectedData] = useState([])
  const [shipmentData, setShipmentData] = useState([])
  const [paylodArray, setPlayloadArray] = useState([])
  const [isShipmentCreating, setShipmentLoader] = useState(false)

  const [showShipmentConfirmModel, setShowShipmentConfirmModel] =
    useState(false)
  const [showPdfModel, setShowPdfModel] = useState(false)
  const [isDelete, setIsDelete] = useState(false)
  const [isAllowHideSection, setHideSections] = useState(false)
  const [labelBlob, setLabelBlob] = useState("")

  const [shipmentIds, setCreatedShipmentIds] = useState([])
  const [shipmentDeliveryPartners, setDeliveryPartnersOfCreatedShipment] =
    useState([])

  const [printLabelShipmentId, setPrintLabelShipmentId] = useState(null)
  const [printLabelLoader, setPrintLabelLoader] = useState(false)

  const [orderShipments, setOrderShipments] = useState([])
  const [orderShipmentsSize, setOrderShipmentsSize] = useState([])
  const [isExistingShipment, setIsExistingShipment] = useState(false)

  const [showPackageDetailModel, setShowPackageDetailModel] = useState(false)
  const [activeShipmentDetail, setShipmentDetail] = useState(null)
  const [customerDetail, setCustomerDetail] = useState(null)
  const [deliveryPartner, setDeliveryPartner] = useState(null)
  const [activeShipmentId, setActiveShipmentId] = useState(null)
  const [activeShipmentIndex, setActiveShipmentIndex] = useState(null)
  const [packageInformationData, setPackageInformationData] = useState([])

  const [confirmShipmentIds, setConfirmShipmentIds] = useState([])

  const [finalShipmentPayloadData, setFinalShipmentPayloadData] = useState([])

  const [oldPayloadArray, setOldPayloadArray] = useState([])
  const [isDpdShipmentLoading, setIsDpdShipmentLoading] = useState(false)

  const [isDropship, setIsDropship] = useState(false)
  const [isDropshipAddedProduct, setIsDropshipAddedProduct] = useState(false)

  const [checkedArrayDropshipSelection, setCheckedArrayDropshipSelection] =
    useState([])
  const [dropshipData, setDropshipData] = useState([])

  // Return and Exchange shipment states
  const [returnShipments, setReturnShipments] = useState([])
  const [showReturnExchangeModal, setShowReturnExchangeModal] = useState(false)
  const [returnExchangeType, setReturnExchangeType] = useState(null)
  const [selectedReturnProducts, setSelectedReturnProducts] = useState([])
  const [availableProductsForReturn, setAvailableProductsForReturn] = useState([])
  const [returnedProductsByShipment, setReturnedProductsByShipment] = useState({})

  const [getReturnShipments] = useLazyQuery(GET_RETURN_SHIPMENTS_BY_ORDER_ID, {
    onCompleted: data => {
      const returnShipments = data?.getReturnShipmentsByOrderId || []
      const returnedProducts = {}
      returnShipments.forEach(returnShipment => {
        returnShipment.products.forEach(product => {
          const shipmentId = product.original_shipment_id
          if (!returnedProducts[shipmentId]) {
            returnedProducts[shipmentId] = new Set()
          }
          returnedProducts[shipmentId].add(product.product_id)
        })
      })

      Object.keys(returnedProducts).forEach(shipmentId => {
        returnedProducts[shipmentId] = Array.from(returnedProducts[shipmentId])
      })
      setReturnedProductsByShipment(returnedProducts)
    },
  })

  const [products, { loading }] = useLazyQuery(GET_ORDER_PRODUCTS_BY_ID, {
    onCompleted: data => {
      setOrderNotes(data?.GetProductOrdersById?.notes || "")
      setOrderData(data?.GetProductOrdersById)

      setLabels([])
      if (data?.GetProductOrdersById?.shipping) {
        setCustomerData([data?.GetProductOrdersById?.shipping])
        setCustomerDetail(data?.GetProductOrdersById?.shipping)
      } else {
        setCustomerData([])
      }
      let groupedBy = _.groupBy(
        data?.GetProductOrdersById?.items,
        "deliveryPartner"
      )
      delete groupedBy["---"]
      setGroupedData(groupedBy)

      if (data?.GetProductOrdersById?.shipments) {
        setOrderShipmentsSize(
          data?.GetProductOrdersById?.shipments?.map((item, index) => index + 1)
        )

        setIsExistingShipment(true)

        // setOrderShipments(prev => {
        //   return [
        //     // ...prev,
        //     data?.GetProductOrdersById?.shipments?.map(shipment => ({
        //       items: shipment?.product_id,
        //       shipmentId: shipment?.shipment_id,
        //       delivery_partner: shipment?.delivery_partner,
        //       print_lable_status: shipment?.label_status ?? false,
        //     })) || [],
        //   ]
        // })

        setOrderShipments(
          data?.GetProductOrdersById?.shipments?.map(shipment => ({
            items: shipment?.product_id,
            shipmentId: shipment?.shipment_id,
            delivery_partner: shipment?.delivery_partner,
            print_lable_status: shipment?.label_status ?? false,
            csv_status: shipment?.csv_status ?? 'pending',
          })) || [],
        )
      }

      if (data?.GetProductOrdersById?.order_id) {
        getReturnShipments({ variables: { orderId: data.GetProductOrdersById.order_id } })
      }
    },
  })

  const [deliveryPartners] = useLazyQuery(GET_ALL_DELIVERY_PARTNERS, {
    onCompleted: data => {
      setDeliveryPartnersData([{ name: "---" }, ...data.DeliveryPartners])
    },
  })

  const getProductsHandle = e => {
    e.preventDefault()
    if (!orderId) {
      setOrderData("")
      return toast.warn("Enter Order ID")
    }
    navigate(`${LINKS.orders}/${orderId}`)
  }

  const sendEmailHandle = () => {
    if (!orderId) return toast.warn("Enter Order ID")
    sendEmail("sendEmail", {
      input: { emailData: JSON.stringify(groupedData) },
      orderId,
    }).then(res => {
      toast.success("Email sent successfully")
      setOrderId("")
      setOrderData("")
      setCustomerData([])
      setGroupedData({})
      navigate(`${LINKS.orders}`)
    })
  }

  const notesSubmitHandle = e => {
    e.preventDefault()
    if (!orderId) return toast.warn("Enter Order ID")
    if (!orderNotes || orderNotes.trim() === "") {
      return toast.warn("Please add valid Note")
    }
    addOrderNotes({
      variables: {
        id: parseInt(orderId),
        input: { notes: orderNotes },
      },
    }).then(resp => {
      if (resp?.data?.AddOrderNotes) {
        toast.success("Notes Added")
      }
    })
  }

  useEffect(() => {
    setmoveSelectedData(orderData?.items)
  }, [orderData])

  useEffect(() => {
    deliveryPartners()
  }, [id])

  useEffect(() => {
    if (!id) return

    setOrderId(parseInt(id))
    products({
      variables: {
        getProductOrdersById: parseInt(id),
      },
    })
  }, [id])

  const setCustomTimeHandle = (id, partner, deliveryTime) => {
    setGroupedData(prevGroupedData => {
      const updatedGroupedData = { ...prevGroupedData }
      const partnerGroup = updatedGroupedData[partner]

      if (partnerGroup) {
        const updatedPartnerGroup = partnerGroup.map(item =>
          item._id === id ? { ...item, deliveryTime } : item
        )
        updatedGroupedData[partner] = updatedPartnerGroup
      }

      return updatedGroupedData
    })
  }

  const shipmentHandle = () => {
    setHideSections(false)

    setIsExistingShipment(false)

    setPlayloadArray(pre => [
      ...pre?.map(subArray => subArray?.map(o => ({ ...o, isShipped: true }))),
      [],
    ])

    setShipment(pre => {
      if (pre.length > 0) return [...pre, pre[pre.length - 1] + 1]
      else return [1]
    })

    setConfirmShipmentIds(prev => [...prev, null])
    setFinalShipmentPayloadData(prev => [...prev, null])
  }

  const dropshipHandle = () => {
    setIsDropship(true)
    setDropship([1])
  }

  const selectedProducts = (value, flag) => {
    setSelectedId(prevSelectedId => {
      if (prevSelectedId.includes(value)) {
        return prevSelectedId.filter(id => id !== value)
      } else {
        return [...prevSelectedId, value]
      }
    })
  }

  const handleSelectedDropshipProducts = (main_id, product_id) => {
    setSelectedDropshipProductId(prevSelectedId => {
      const exists = prevSelectedId.some(obj => obj.id === main_id)
      if (exists) {
        return prevSelectedId.filter(obj => obj.id !== main_id)
      } else {
        return [...prevSelectedId, { id: main_id, product_id: product_id }]
      }
    })
  }

  const submitAllShipmentHandle = () => {
    if (
      !finalShipmentPayloadData.some(
        innerArray => innerArray?.package_info?.length > 0
      )
    ) {
      toast.warn("Please add detail inside shipments")
      return
    }

    let res = getPickupAndDeliveryDays()

    setShipmentLoader(true)

    let newPayloadArray = [...finalShipmentPayloadData.filter(o => Boolean(o))]

    const createShipmentArray = []
    for (let i = 0; i < newPayloadArray.length; i++) {
      let subArray = []
      let products_ids = []
      if (newPayloadArray[i]?.package_info?.length > 0) {
        for (let j = 0; j < newPayloadArray[i]?.package_info?.length; j++) {
          let PickUpAddress = newPayloadArray[i].package_info[j].supplier
            ? SHIPMENT_SUPPLIER.find(
              o => o.value === newPayloadArray[i]?.package_info[j]?.supplier
            ).PickUp
            : SHIPMENT_SUPPLIER[1].PickUp

          let packing = newPayloadArray[i]?.package_info[j]?.productName

          if (newPayloadArray[i]?.deliveryPartner == "Logique") {
            packing = "Pakket klein"
          }

          if (newPayloadArray[i]?.deliveryPartner == "Maxpakket") {
            packing = newPayloadArray[i]?.package_info[j]?.packages?.[0]?.Packing || "MAX M"
          }

          subArray.push({
            Packing: packing,
            Barcode: "",
            Comments: "",
            Parts: newPayloadArray[i]?.package_info[j]?.packages?.length,
            Packages: newPayloadArray[i]?.package_info[j]?.packages, // volume added additionally
            Quantity: newPayloadArray[i]?.package_info[j]?.quantity,
            Sku: newPayloadArray[i]?.package_info[j]?.sku,
            PickUp: newPayloadArray[i]?.isReturnShipment ? {
              // For return shipments, pickup becomes the customer address
              ReferenceOur: `#${orderId}`,
              ReferenceYour: `ref-${orderId}`,
              Address: {
                Name: customerDetail?.name,
                Premise: customerDetail?.address,
                Street: address,
                Number: customerDetail?.house_number,
                PostalCode: customerDetail?.postal_code,
                Place: customerDetail?.city,
                Country: "Nederland",
                CountryCode: customerDetail?.country,
              },
              ContactName: customerDetail?.name,
              Instructions: newPayloadArray[i]?.package_info[j]?.pickup_instruction,
              Requested: {
                DateTimeBegin: formatDate(res.pickup.start),
                DateTimeEnd: formatDate(res.pickup.end),
              },
              Connectivity: {
                Email: customerDetail?.email,
                Phone: customerDetail?.telephone,
              },
            } : {
              ...PickUpAddress, // static address (will replace soon) - need client help for this
              // ...SHIPMENT_SUPPLIER.find(o => o.value === finalShipmentPayloadData[i]?.package_info[j]?.supplier).PickUp,
              Instructions:
                newPayloadArray[i]?.package_info[j]?.pickup_instruction, // "Ophaalinstructies" // think on it for both prtner may be diffrent payload
              // ReferenceOur: "#8746",
              // ReferenceYour: "ref-1234",
              Requested: {
                DateTimeBegin: formatDate(res.pickup.start), // "2020-01-04T09:00:00",
                DateTimeEnd: formatDate(res.pickup.end), // "2020-01-04T17:00:00",
              },
              ReferenceOur: `#${orderId}`,
              ReferenceYour: `ref-${orderId}`,
            },
            Supplier: newPayloadArray[i]?.package_info[j]?.supplier,

            // Parts: newPayloadArray[i][j].quantity,
            // Depth: 1.1,
            // Height: 1.1,
            // Width: 1.1,
            // VolumeWeight: 1.1,
            // ArticleWeight: 1.1,
            // Weight: 1.1,
          })
          products_ids.push(newPayloadArray[i]?.package_info[j]?.product_id)
        }
      }

      const removeSpecificStreetNumber = (address, streetNumber) => {
        if (address && streetNumber) {
          // Create a regex to match the specific street number at the end of the string
          const streetNumberRegex = new RegExp(`\\s${streetNumber}$`)
          return address.replace(streetNumberRegex, "")
        }
        return address
      }

      const streetNumber = customerDetail?.house_number
      let address = removeSpecificStreetNumber(
        customerDetail?.address,
        streetNumber
      )

      const mainObject = {
        order_id: orderId,
        Contact: customerDetail?.name, // "Contact Persoon Logique",
        Notes: `Notities ${newPayloadArray[i]?.deliveryPartner || 'Logique'}`,
        product_id: products_ids,
        GoodList: subArray,

        PickUp: newPayloadArray[i]?.isReturnShipment ? {
          // For return shipments, pickup becomes the customer address
          ReferenceOur: `#${orderId}`,
          ReferenceYour: `ref-${orderId}`,
          Address: {
            Name: customerDetail?.name,
            Premise: customerDetail?.address,
            Street: address,
            Number: customerDetail?.house_number,
            PostalCode: customerDetail?.postal_code,
            Place: customerDetail?.city,
            Country: "Nederland",
            CountryCode: customerDetail?.country,
          },
          ContactName: customerDetail?.name,
          Instructions: newPayloadArray[i]?.deliveryInfo?.delivery_instruction,
          Requested: {
            DateTimeBegin: formatDate(res.pickup.start),
            DateTimeEnd: formatDate(res.pickup.end),
          },
          Connectivity: {
            Email: customerDetail?.email,
            Phone: customerDetail?.telephone,
          },
        } : subArray[0]?.PickUp, // tempororay pass here that should be access from above mention loop of subArray
        // PickUp: {
        //   Instructions: "Ophaalinstructies", // what to do with this now as pickup instruction are inside good list for each product
        //   ReferenceOur: "#8746",
        //   ReferenceYour: "ref-1234",
        //   Requested: {
        //     DateTimeBegin: formatDate(new Date()), // "2020-01-04T09:00:00",
        //     DateTimeEnd: formatDate(new Date()) // "2020-01-04T17:00:00",
        //   },
        // },

        Delivery: newPayloadArray[i]?.isReturnShipment ? {
          // For return shipments, delivery becomes the original pickup address (supplier)
          ReferenceOur: `#${orderId}`,
          ReferenceYour: `ref-${orderId}`,
          Address: {
            Name: PickUpAddress?.ContactName || "Supplier",
            Premise: PickUpAddress?.Address?.Name || "",
            Street: PickUpAddress?.Address?.Street || "",
            Number: PickUpAddress?.Address?.Number || "",
            PostalCode: PickUpAddress?.Address?.PostalCode || "",
            Place: PickUpAddress?.Address?.Place || "",
            Country: PickUpAddress?.Address?.Country || "Nederland",
            CountryCode: PickUpAddress?.Address?.CountryCode || "NL",
          },
          ContactName: PickUpAddress?.ContactName || "Supplier",
          Instructions: newPayloadArray[i]?.deliveryInfo?.delivery_instruction,
          Requested: {
            DateTimeBegin: formatDate(res.delivery.start),
            DateTimeEnd: formatDate(res.delivery.end),
          },
          Connectivity: {
            Email: PickUpAddress?.Connectivity?.Email || "supplier@example.com",
            Phone: PickUpAddress?.Connectivity?.Phone || "",
          },
        } : {
          // Normal shipment - original logic
          ReferenceOur: `#${orderId}`,
          ReferenceYour: `ref-${orderId}`,
          Address: {
            Name: customerDetail?.name, // "Piet Klant",
            Premise: customerDetail?.address, // "expeditie",
            Street: `${address}`,
            Number: customerDetail?.house_number, // "123",
            PostalCode: customerDetail?.postal_code, //"1234 AB",
            Place: customerDetail?.city, // "Ede",
            Country: "Nederland",
            CountryCode: customerDetail?.country, // "NL",
          },
          ContactName: customerDetail?.name, //"Piet Klant",
          Instructions: newPayloadArray[i]?.deliveryInfo?.delivery_instruction, // "Instructies afleveren",
          // ReferenceOur: "#8746",
          // ReferenceYour: "ref-1234",
          Requested: {
            DateTimeBegin: formatDate(res.delivery.start), // "2020-01-05T09:00:00",
            DateTimeEnd: formatDate(res.delivery.end), // "2020-01-05T17:00:00",
          },
          Connectivity: {
            Email: customerDetail?.email, //"piet@klant.nl",
            Phone: customerDetail?.telephone, //"012-2345678",
          },
        },
        DeliveryPartner: newPayloadArray[i]?.deliveryPartner, // "Logique"

        // Only for DusselDrop partner required
        OrderType: newPayloadArray[i]?.deliveryInfo?.orderType,
        ServiceType: newPayloadArray[i]?.deliveryInfo?.service,
        Floor: newPayloadArray[i]?.deliveryInfo?.floor,
        Lift: newPayloadArray[i]?.deliveryInfo?.elevator,
        // For DPD Pickup
        // service_point_id:
        //   newPayloadArray[i]?.service_point_id || orderData?.service_point_id,
      }

      createShipmentArray.push(mainObject)
    }
    new Promise((resolve, reject) => {
      resolve(
        addShipment({
          variables: {
            input: createShipmentArray,
          },
        })
      )
    })
      .then(resp => {
        if (resp?.data?.createShipment) {
          toast.success("All Shipment has been shipped")

          setCreatedShipmentIds(prev => [
            ...prev,
            ...resp?.data?.createShipment?.shipmentIds,
          ])
          setDeliveryPartnersOfCreatedShipment(prev => [
            ...prev,
            ...resp?.data?.createShipment?.deliveryPartners,
          ])

          setHideSections(true)
          setFinalShipmentPayloadData([]) // added new

          const length = paylodArray?.length //resp?.data?.createShipment?.shipmentIds?.length;
          const mainArray = []
          for (let i = 0; i < length; i++) {
            mainArray.push([])
          }

          setOldPayloadArray(prev => [...prev, ...paylodArray.filter(o => o.length)]) // added new dm
          setPlayloadArray(mainArray) // chpage position from top to bottom // temp
          // setPlayloadArray([[]])
          setShipment([])
          products({
            variables: {
              getProductOrdersById: parseInt(orderId),
            },
          })
        }
      })
      .catch(err => {
        toast.error(`Shipment creation failed: ${err.message}`)
      })
      .finally(() => {
        setShipmentLoader(false)
      })
  }

  const handleRetryShipment = async (shipmentId) => {
    try {
      const { data } = await retryShipmentCSVMutation({ variables: { shipment_id: shipmentId } })
      if (data?.retryShipmentCSV?.success) {
        toast.success('Shipment CSV re-uploaded successfully')
        setOrderShipments(prev => prev.map(s =>
          s.shipmentId === shipmentId ? { ...s, csv_status: 'sent' } : s
        ))
      } else {
        toast.error(data?.retryShipmentCSV?.message || 'Retry failed')
      }
    } catch (err) {
      toast.error('Retry failed: ' + err.message)
    }
  }

  const handleTogglePdfModel = (shipmentId, shipmentDeliveryPartner) => {
    setPrintLabelShipmentId(shipmentId)
    setPrintLabelLoader(true)
    new Promise((resolve, reject) => {
      resolve(
        printLabel({
          variables: {
            input: {
              orderId: shipmentId,
              deliveryPartner: shipmentDeliveryPartner,
            },
          },
        })
      )
    })
      .then(resp => {
        if (resp.data.createLabel.stream != null) {
          setLabelBlob(resp?.data?.createLabel?.stream)
          setShowPdfModel(!showPdfModel)
        }
      })
      .catch(err => {
        toast.error("Oops! Something went wrong while printing label")
      })
      .finally(() => {
        setPrintLabelLoader(false)
      })
  }

  const handleToggleShipmentConfirmModel = () => {
    setShowShipmentConfirmModel(!showShipmentConfirmModel)
  }

  const handleDelete = () => {
    setIsDelete(false)
  }

  const getModelStatus = () => {
    return showShipmentConfirmModel
  }

  const onConfirmClick = () => {
    setIsDelete(true)
    setShowShipmentConfirmModel(false)
  }

  const handleTogglePackagDetailModel = () => {
    setShowPackageDetailModel(!showPackageDetailModel)
  }

  const setShipmentDetailData = (
    detail,
    deliveryPartner,
    shipmentId,
    shipmentIndex
  ) => {
    setShipmentDetail(detail)
    setDeliveryPartner(PARTNERS?.find(o => o.value == deliveryPartner)?.label)
    setActiveShipmentId(shipmentId)
    setActiveShipmentIndex(shipmentIndex)
  }

  const getFormData = async data => {
    // Check if this is a return/exchange shipment
    if (showReturnExchangeModal) {
      handleReturnExchangeConfirm(data)
      return
    }

    if (data?.deliveryPartner === "DPD Pickup") {
      let GoodList = []
      let product_ids = []
        ; (data.package_info || []).forEach(pkg => {
          GoodList.push({
            Packing: pkg.productName,
            Quantity: pkg.quantity,
            Supplier: pkg.supplier,
            Packages: (pkg.packages || []).map(p => ({
              Length: p.Depth,
              Depth: p.Depth,
              Height: p.Height,
              Width: p.Width,
              Weight: p.Weight,
              ArticleWeight: p.ArticleWeight,
              Price: p.Price,
            })),
          })
          if (pkg.product_id) product_ids.push(pkg.product_id)
        })

      // Remove street number from address (same as submitAllShipmentHandle)
      const removeSpecificStreetNumber = (address, streetNumber) => {
        if (address && streetNumber) {
          const streetNumberRegex = new RegExp(`\\s${streetNumber}$`)
          return address.replace(streetNumberRegex, "")
        }
        return address
      }
      const streetNumber = customerDetail?.house_number
      let address = removeSpecificStreetNumber(
        customerDetail?.address,
        streetNumber
      )

      // Build the mainObject
      const mainObject = {
        order_id: orderId,
        Contact: customerDetail?.name,
        Notes: orderNotes,
        product_id: product_ids,
        GoodList: GoodList,
        PickUp: GoodList[0]?.PickUp,
        Delivery: {
          ReferenceOur: `#${orderId}`,
          ReferenceYour: `ref-${orderId}`,
          Address: {
            Name: customerDetail?.name,
            Premise: customerDetail?.address,
            Street: address,
            Number: customerDetail?.house_number,
            PostalCode: customerDetail?.postal_code,
            Place: customerDetail?.city,
            Country: "Nederland",
            CountryCode: customerDetail?.country,
          },
          ContactName: customerDetail?.name,
          Instructions: data?.deliveryInfo?.delivery_instruction,
          Requested: {
            DateTimeBegin: formatDate(new Date()),
            DateTimeEnd: formatDate(new Date()),
          },
          Connectivity: {
            Email: customerDetail?.email,
            Phone: customerDetail?.telephone,
          },
        },
        DeliveryPartner: data?.deliveryPartner,
        OrderType: data?.deliveryInfo?.orderType,
        ServiceType: data?.deliveryInfo?.service,
        service_point_id: data?.service_point_id,
        Floor: data?.deliveryInfo?.floor,
        Lift: data?.deliveryInfo?.elevator,
      }

      try {
        setIsDpdShipmentLoading(true)
        const resp = await addShipment({
          variables: { input: [mainObject] },
        })

        if (resp?.data?.createShipment) {
          toast.success("DPD Pickup shipment created!")
          setCreatedShipmentIds(prev => [
            ...prev,
            ...resp?.data?.createShipment?.shipmentIds,
          ])
          setDeliveryPartnersOfCreatedShipment(prev => [
            ...prev,
            ...resp?.data?.createShipment?.deliveryPartners,
          ])
          setFinalShipmentPayloadData([])

          const length = paylodArray?.length
          const mainArray = []
          for (let i = 0; i < length; i++) {
            mainArray.push([])
          }

          setOldPayloadArray(prev => [
            ...prev,
            ...paylodArray.filter(o => o.length),
          ])
          setPlayloadArray(mainArray)

          setHideSections(true)
          handleTogglePackagDetailModel()
        }
      } catch (err) {
        setHideSections(true)
        toast.error("Failed to create DPD Pickup shipment: " + err.message)
      } finally {
        setIsDpdShipmentLoading(false)
      }
    } else {
      managePackageInformationData(data)
      handleTogglePackagDetailModel()

      const confirmShipmentIdsCopy = [...confirmShipmentIds]
      confirmShipmentIdsCopy[activeShipmentIndex] =
        data?.package_info[0]?.product_id
      setConfirmShipmentIds(confirmShipmentIdsCopy)

      const finalShipmentPayloadDataCopy = [...finalShipmentPayloadData]
      finalShipmentPayloadDataCopy[activeShipmentIndex] = data
      setFinalShipmentPayloadData(finalShipmentPayloadDataCopy)
    }
  }

  const managePackageInformationData = data => {
    setPackageInformationData(prev => [
      ...prev,
      {
        shipmentId: activeShipmentId,
        delivery_info: data?.deliveryInfo,
        customer_info: customerDetail,
        package_info: data?.package_info,
      },
    ])
  }

  const columns = useMemo(
    () => [
      {
        Header: "Product ID",
        accessor: "product_id",
        Cell: ({ value }) => {
          return <span>{value}</span>
        },
      },
      {
        Header: "Name",
        accessor: "item.name",
        Cell: ({ value }) => {
          return <span>{value}</span>
        },
      },
      {
        Header: "Quantity",
        accessor: "quantity",
      },
      {
        Header: "Price",
        accessor: "price",
        Cell: price => {
          return (
            <span>
              {price.value?.toFixed(2)} {price.cell.row.original.currency}
            </span>
          )
        },
      },
      {
        Header: "Total",
        accessor: "total",
        Cell: total => {
          return (
            <span>
              {total.value?.toFixed(2)} {total.cell.row.original.currency}
            </span>
          )
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: status => {
          return (
            <div className="branch_status">
              <select
                className="form-select"
                style={{ minWidth: 140, textTransform: "capitalize" }}
                data-id={status.row.original._id}
                value={status?.value || ""}
                onChange={e =>
                  updateStatus("updateStatus", {
                    input: { status: e.target.value },
                    productId: status.cell.row.original._id,
                    orderId: orderData?.order_id,
                  }).then(res => {
                    toast.success("Status Updated!")
                  })
                }
              >
                {ORDER_STATUS &&
                  ORDER_STATUS.map((oStatus, i) => (
                    <option key={i} value={oStatus}>
                      {oStatus}
                    </option>
                  ))}
              </select>
            </div>
          )
        },
      },
      {
        Header: "Estimated Time",
        accessor: "item.estimate",
        Cell: ({ value }) => {
          return <span>{value}</span>
        },
      },
      {
        Header: "Delivery Time",
        accessor: "deliveryTime",
        Cell: deliveryTime => {
          return (
            <div className="branch_status" style={{ maxWidth: 300 }}>
              <select
                className="form-select"
                style={{ minWidth: 140, textTransform: "uppercase" }}
                data-id={deliveryTime.row.original._id}
                value={deliveryTime?.value || ""}
                onChange={e =>
                  setCustomTimeHandle(
                    deliveryTime.cell.row.original._id,
                    deliveryTime.cell.row.original.deliveryPartner,
                    e.target.value
                  )
                }
              >
                {DELIVERY_TIMES &&
                  DELIVERY_TIMES.map(time => (
                    <option key={time} value={time}>
                      {time}
                    </option>
                  ))}
              </select>
            </div>
          )
        },
      },
      {
        Header: "Previous Shipment",
        accessor: "preferred_shipping_method",
        Cell: ({ value, row }) => {
          if (!value) {
            return <span>-</span>
          }

          const baseStyle = {
            color: "white",
            border: "none",
            borderRadius: "4px",
            padding: "8px",
            fontSize: "12px",
            fontWeight: "500",
            maxWidth: "111px",
            width: "100%",
            textAlign: "center",
            cursor: "pointer",
          }

          return (
            <button
              style={{
                ...baseStyle,
                backgroundColor: shippingColors[value] || "#6c757d",
              }}
            >
              {value}
            </button>
          )
        },
      },
    ],
    [orderData]
  )

  const dropshipColumns = useMemo(
    () => [
      {
        Header: "Product ID",
        accessor: "product_id",
        Cell: ({ value }) => {
          return <span>{value}</span>
        },
      },
      {
        Header: "SKU",
        accessor: "item.sku",
        Cell: ({ value }) => {
          return <span>{value}</span>
        },
      },
      {
        Header: "Name",
        accessor: "item.name",
        Cell: ({ value }) => {
          return <span>{value}</span>
        },
      },
      {
        Header: "Quantity",
        accessor: "quantity",
      },
      {
        Header: "Price",
        accessor: "price",
        Cell: price => {
          return (
            <span>
              {price.value?.toFixed(2)} {price.cell.row.original.currency}
            </span>
          )
        },
      },
      {
        Header: "Total",
        accessor: "total",
        Cell: total => {
          return (
            <span>
              {total.value?.toFixed(2)} {total.cell.row.original.currency}
            </span>
          )
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: status => {
          return (
            <div className="branch_status">
              <select
                className="form-select"
                style={{ minWidth: 140, textTransform: "capitalize" }}
                data-id={status.row.original._id}
                value={status?.value || ""}
                onChange={e =>
                  updateStatus("updateStatus", {
                    input: { status: e.target.value },
                    productId: status.cell.row.original._id,
                    orderId: orderData?.order_id,
                  }).then(res => {
                    toast.success("Status Updated!")
                  })
                }
              >
                {ORDER_STATUS &&
                  ORDER_STATUS.map((oStatus, i) => (
                    <option key={i} value={oStatus}>
                      {oStatus}
                    </option>
                  ))}
              </select>
            </div>
          )
        },
      },
      {
        Header: "Estimated Time",
        accessor: "item.estimate",
        Cell: ({ value }) => {
          return <span>{value}</span>
        },
      },
    ],
    [orderData]
  )

  const shipmentColumns = useMemo(
    () => [
      {
        Header: "Product ID",
        accessor: "product_id",
        Cell: ({ value }) => {
          return <span>{value}</span>
        },
      },
      {
        Header: "Name",
        accessor: "item.name",
        Cell: ({ value }) => {
          return <span>{value}</span>
        },
      },
      {
        Header: "Quantity",
        accessor: "quantity",
      },
      {
        Header: "Price",
        accessor: "price",
        Cell: price => {
          return (
            <span>
              {price.value?.toFixed(2)} {price.cell.row.original.currency}
            </span>
          )
        },
      },
      {
        Header: "Total",
        accessor: "total",
        Cell: total => {
          return (
            <span>
              {total.value?.toFixed(2)} {total.cell.row.original.currency}
            </span>
          )
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: status => {
          return <span>{status.value}</span>
        },
      },
      {
        Header: "Estimated Time",
        accessor: "item.estimate",
        Cell: ({ value }) => {
          return <span>{value}</span>
        },
      },
      {
        Header: "Delivery Time",
        accessor: "deliveryTime",
        Cell: deliveryTime => {
          return <span>{deliveryTime.value}</span>
        },
      },
    ],
    [orderData]
  )

  const customerTableColumns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Telephone",
        accessor: "telephone",
      },
      {
        Header: "Address",
        accessor: "address",
      },
      {
        Header: "City",
        accessor: "city",
      },
      {
        Header: "Country",
        accessor: "country",
      },
    ],
    [customerData]
  )
  document.title = "Order | Order Processing"
  const renderShipmentConfirmation = () => {
    if (deliveryPartner === "Jos Dusseldorp") {
      return (
        <ShipmentConfirmationForDusselDrop
          show={showPackageDetailModel}
          tittle={showReturnExchangeModal ? `Confirm ${returnExchangeType === 'return' ? 'Return' : 'Exchange'} Shipment` : "Confirm Shipment"}
          deliveryPartner={deliveryPartner}
          onCloseClick={handleTogglePackagDetailModel}
          onConfirmClick={getFormData}
          activeShipmentDetail={activeShipmentDetail}
          customerDetail={customerDetail}
          defaultValues={packageInformationData?.find(
            o => o.shipmentId === activeShipmentId
          )}
          isReturnExchange={showReturnExchangeModal}
          returnExchangeType={returnExchangeType}
        />
      )
    } else if (deliveryPartner === "Logique") {
      return (
        <ShipmentConfirmationForLogique
          show={showPackageDetailModel}
          tittle="Confirm Shipment"
          deliveryPartner={"Logique"}
          onCloseClick={handleTogglePackagDetailModel}
          onConfirmClick={getFormData}
          activeShipmentDetail={activeShipmentDetail}
          customerDetail={customerDetail}
          defaultValues={packageInformationData?.find(
            o => o.shipmentId === activeShipmentId
          )}
        />
      )
    } else if (deliveryPartner === "Maxpakket") {
      return (
        <ShipmentConfirmationForMaxpakket
          show={showPackageDetailModel}
          tittle="Confirm Shipment"
          deliveryPartner={"Maxpakket"}
          onCloseClick={handleTogglePackagDetailModel}
          onConfirmClick={getFormData}
          activeShipmentDetail={activeShipmentDetail}
          customerDetail={customerDetail}
          defaultValues={packageInformationData?.find(
            o => o.shipmentId === activeShipmentId
          )}
        />
      )
    } else if (deliveryPartner === "DPD Pickup") {
      return (
        <ShipmentConfirmationForDPDPickup
          show={showPackageDetailModel}
          tittle="Confirm DPD Pickup Shipment"
          deliveryPartner={deliveryPartner}
          onCloseClick={handleTogglePackagDetailModel}
          onConfirmClick={getFormData}
          activeShipmentDetail={activeShipmentDetail}
          customerDetail={customerDetail}
          service_point_id={orderData?.service_point_id}
          defaultValues={packageInformationData?.find(
            o => o.shipmentId === activeShipmentId
          )}
          isDpdShipmentLoading={isDpdShipmentLoading}
        />
      )
    } else {
      return (
        <ShipmentConfirmationForDPD
          show={showPackageDetailModel}
          tittle="Confirm Shipment"
          deliveryPartner={deliveryPartner}
          onCloseClick={handleTogglePackagDetailModel}
          onConfirmClick={getFormData}
          activeShipmentDetail={activeShipmentDetail}
          customerDetail={customerDetail}
          defaultValues={packageInformationData?.find(
            o => o.shipmentId === activeShipmentId
          )}
        />
      )
    }
  }

  const handleDropshipTableOnCancelClick = () => {
    setIsDropship(false)
    setSelectedDropshipProductId([])
    setDropship([])
    setIsDropshipAddedProduct(false)
  }

  const clearSelectedDropshipProductId = () => {
    setSelectedDropshipProductId([])
    setCheckedArrayDropshipSelection([])
  }

  const handleCreateReturnFromExistingShipments = () => {
    // Get products only from Jos Dusseldorp shipments for return selection
    const josDusseldorpShipments = orderShipments.filter(shipment => shipment?.delivery_partner === "Jos Dusseldorp")
    if (josDusseldorpShipments.length === 0) {
      toast.warn("No Jos Dusseldorp shipments found for return!")
      return
    }

    const allExistingProducts = josDusseldorpShipments.flatMap((shipment, shipmentIndex) => {
      const returnedProductIds = returnedProductsByShipment[shipment.shipmentId] || []
      return (shipment.items || [])
        .filter(item => !returnedProductIds.includes(item.product_id))
        .map(item => ({
          ...item,
          originalShipmentId: shipment.shipmentId,
          originalShipmentIndex: shipmentIndex
        }))
    })

    if (allExistingProducts.length === 0) {
      toast.warn("No available products for return! All products from Jos Dusseldorp shipments have already been returned.")
      return
    }

    setReturnExchangeType('return')
    setSelectedReturnProducts([])
    setAvailableProductsForReturn(allExistingProducts)
    setShowReturnExchangeModal(true)
  }

  const handleCreateExchangeFromExistingShipments = () => {
  }

  const handleSelectReturnProduct = (product) => {
    setSelectedReturnProducts(prev => {
      const isSelected = prev.some(p => p.product_id === product.product_id)
      if (isSelected) {
        return prev.filter(p => p.product_id !== product.product_id)
      } else {
        return [...prev, product]
      }
    })
  }

  const handleAddSelectedProducts = () => {
    // Check if any products are selected
    if (selectedReturnProducts.length === 0) {
      toast.warn("Please select products to add to return shipment!")
      return
    }

    // Store the count and products before any modifications
    const addedCount = selectedReturnProducts.length
    const productsToMove = [...selectedReturnProducts] // Create a copy

    // First, find the original shipment index for each product BEFORE removing them
    const productsWithShipmentInfo = productsToMove.map(product => ({
      ...product,
      originalShipmentIndex: orderShipments.findIndex(shipment =>
        shipment.items?.some(item => item.product_id === product.product_id)
      )
    }))

    const updatedShipments = orderShipments.map(shipment => {
      // Filter out products that are being moved to return shipment
      const remainingItems = shipment.items?.filter(item => {
        const shouldRemove = productsToMove.some(selectedProduct => {
          const isMatch = selectedProduct.product_id === item.product_id
          if (isMatch) {
            console.log(`Found match: ${selectedProduct.product_id} === ${item.product_id}`)
          }
          return isMatch
        })
        return !shouldRemove
      }) || []

      return {
        ...shipment,
        items: remainingItems
      }
    })
    setOrderShipments([...updatedShipments])
    // Add selected products to the return shipment table
    setReturnShipments(prev => [...prev, ...productsWithShipmentInfo])
    setSelectedReturnProducts([])
    toast.success(`${addedCount} product(s) added to return shipment!`)
  }

  const handleSubmitReturnExchange = () => {
    // Process the return/exchange shipment - check if there are products in return shipment
    if (returnShipments.length === 0) {
      toast.warn("Please add products to return shipment first!")
      return
    }
    setShipmentDetail(returnShipments)
    setDeliveryPartner("Jos Dusseldorp")
    setShowPackageDetailModel(true)
  }

  const handleCancelReturnExchange = () => {
    // Restore products back to their original shipments before canceling
    if (returnShipments.length > 0) {
      setOrderShipments(prevOrderShipments => {
        return prevOrderShipments.map((shipment, shipmentIndex) => {
          // Find products that belong to this specific shipment
          const restoredProducts = returnShipments
            .filter(returnProduct => returnProduct.originalShipmentIndex === shipmentIndex)
            .map(({ originalShipmentIndex, ...product }) => product)
          const updatedItems = [...(shipment.items || []), ...restoredProducts]
          return {
            ...shipment,
            items: updatedItems
          }
        })
      })
    }

    setShowReturnExchangeModal(false)
    setSelectedReturnProducts([])
    setAvailableProductsForReturn([])
    setReturnShipments([])
    setReturnExchangeType(null)
  }

  const handleReturnExchangeConfirm = (formData) => {
    const di = formData?.deliveryInfo || {};
    const productsData = (formData?.package_info || [])
      .map(p => {
        const productInfo = availableProductsForReturn.find(ap => ap.product_id === Number(p?.product_id));
        return {
          product_id: Number(p?.product_id),
          original_shipment_id: productInfo?.originalShipmentId,
          original_shipment_index: productInfo?.originalShipmentIndex
        };
      })
      .filter(p => Number.isInteger(p.product_id) && Number.isInteger(p.original_shipment_id));
    if (!productsData.length) {
      toast.warn('No products selected for return');
      return;
    }

    const input = {
      order_id: Number(orderId),
      product_id: productsData,
      return_type: 'return',
      Contact: di.contact || '',
      Notes: di.delivery_instruction || '',
      DeliveryPartner: formData.deliveryPartner || 'Jos Dusseldorp',
      OrderType: di.orderType || 'B2C Retour',
      ServiceType: di.service || 'Basic 1',
      Floor: di.floor ?? 0,
      Lift: !!di.elevator,
    };

    createReturnShipment({ variables: { input } })
      .then(() => {
        toast.success('Return shipment created');
        setShowReturnExchangeModal(false);
        setReturnShipments([]);

        // Refresh the returned products list
        if (orderId) {
          getReturnShipments({
            variables: { orderId: Number(orderId) },
            onCompleted: (returnData) => {
              const returnShipments = returnData?.getReturnShipmentsByOrderId || []
              const returnedProducts = {}
              returnShipments.forEach(returnShipment => {
                returnShipment.products.forEach(product => {
                  const shipmentId = product.original_shipment_id
                  if (!returnedProducts[shipmentId]) {
                    returnedProducts[shipmentId] = new Set()
                  }
                  returnedProducts[shipmentId].add(product.product_id)
                })
              })

              Object.keys(returnedProducts).forEach(shipmentId => {
                returnedProducts[shipmentId] = Array.from(returnedProducts[shipmentId])
              })
              setReturnedProductsByShipment(returnedProducts)
              products({
                variables: {
                  getProductOrdersById: parseInt(orderId),
                },
              })
            }
          })
        }
      })
      .catch(err => {
        toast.error('Failed to create return shipment');
      });
  };

  return (
    <div className="page-content order-processing">
      {(loading || sendEmailLoading || labelLoading || createReturnShipmentLoading) && <PuffLoading />}
      <div className="container-fluid">
        <Breadcrumbs title="Order Processing" breadcrumbItem="Order" />
        <div>
          <Row>
            <Col md={4} className="d-flex align-items-center">
              <form
                onSubmit={getProductsHandle}
                className="search-box d-flex align-items-center gap-2 mb-4"
              >
                <div className="position-relative">
                  <label htmlFor="search-bar-0" className="search-label mb-0">
                    <span id="search-bar-0-label" className="sr-only">
                      Enter Order ID
                    </span>
                    <input
                      onChange={e => {
                        setOrderId(e.target.value)
                      }}
                      id="search-bar-0"
                      type="number"
                      min={0}
                      className="form-control"
                      placeholder={`Enter Order ID`}
                      value={orderId}
                    />
                  </label>
                  <i className="bx bx-search-alt search-icon"></i>
                </div>
                <button
                  type="submit"
                  className="btn btn-primary waves-effect waves-light btn btn-primary"
                >
                  Search
                </button>
              </form>
            </Col>
          </Row>

          <div className="position-relative order-table">
            {loading && <OvalLoading />}
            <h5>Customer Information</h5>
            <PaginatedTable
              columns={customerTableColumns}
              data={customerData || []}
              isLoading={loading}
            />

            {orderData && (
              <Row className="mb-4">
                <Col md={6} lg={6}>
                  <h5 className="mt-3">Order Notes</h5>
                  <form onSubmit={notesSubmitHandle}>
                    <div>
                      <textarea
                        className="form-control"
                        value={orderNotes}
                        style={{ minHeight: 100 }}
                        placeholder={`Enter Order Notes`}
                        onChange={e => setOrderNotes(e.target.value)}
                        required
                      ></textarea>
                    </div>
                    <button
                      type="submit"
                      className="mt-2 btn btn-primary waves-effect waves-light btn btn-primary"
                    >
                      Add Notes
                    </button>
                  </form>
                </Col>
              </Row>
            )}

            {orderData &&
              Array.isArray(orderData.dropships) &&
              orderData.dropships.length > 0 ? (
              <ExistingDropshipsTable dropships={orderData.dropships} />
            ) : (
              <></>
            )}

            {isShipmentCreating && <ShipmentLoader />}

            {shipment.length && !isAllowHideSection ? (
              <div style={{ textAlign: "right" }}>
                <button
                  className="btn btn-primary waves-effect waves-light btn btn-primary"
                  disabled={
                    shipment?.length !==
                    confirmShipmentIds?.filter(o => Boolean(o))?.length
                  }
                  onClick={submitAllShipmentHandle}
                >
                  Submit all shipment
                </button>
              </div>
            ) : null}

            {orderShipmentsSize?.length > 0 && (
              <div className="shipment-title-wrapper">
                {/* Only show return/exchange buttons if there are Jos Dusseldorp shipments */}
                {orderShipments.some(shipment => shipment?.delivery_partner === "Jos Dusseldorp") && (
                  <div className="shipment-title mb-3 mt-3">
                    <div className="d-flex justify-content-end align-items-center">
                      <div className="d-flex gap-2">
                        <button
                          type="button"
                          className="btn btn-primary waves-effect waves-light"
                          onClick={() => handleCreateReturnFromExistingShipments()}
                        >
                          + Add Return
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary waves-effect waves-light"
                        >
                          + Add Exchange
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {/* Return/Exchange Product Selection Container - Only show when return modal is active */}
                {showReturnExchangeModal && (
                  <div className="shipment-box-wrapper">
                    <ReturnShipmentTable
                      selectedReturnProducts={selectedReturnProducts}
                      returnShipments={returnShipments}
                      onAddSelectedProducts={handleAddSelectedProducts}
                      onSubmitReturnExchange={handleSubmitReturnExchange}
                      onCancelReturnExchange={handleCancelReturnExchange}
                    />
                  </div>
                )}

                {/* Existing Shipments */}
                <div className="shipment-box-wrapper">
                  {orderShipmentsSize.map((item, index) => {
                    return (
                      <ExistingShipmentsTable
                        key={index}
                        shipmentIndex={index}
                        shipmentValue={orderShipments[index]?.shipmentId}
                        shipmentDeliveryPartner={
                          orderShipments[index]?.delivery_partner
                        }
                        hasLiveShipmentId={true}
                        columns={shipmentColumns}
                        existingShipmentData={
                          orderShipments?.length > 0
                            ? orderShipments[index]?.items
                            : []
                        }
                        isAllowHideSection={true}
                        onPrintLabelClick={handleTogglePdfModel}
                        isPrintLabelLoading={printLabelLoader}
                        isShowPrintLabel={
                          orderShipments[index]?.delivery_partner ===
                            "Logique" ||
                            orderShipments[index]?.delivery_partner === "Maxpakket" ||
                            orderShipments[index]?.delivery_partner === "DPD" ||
                            orderShipments[index]?.delivery_partner === "PostNL" ||
                            orderShipments[index]?.delivery_partner ===
                            "DPD Pickup"
                            ? true
                            : orderShipments[index]?.print_lable_status
                        }
                        csvStatus={orderShipments[index]?.csv_status}
                        onRetryClick={handleRetryShipment}
                        isRetryLoading={retryShipmentLoading}
                        showReturnExchangeModal={showReturnExchangeModal}
                        returnExchangeType={returnExchangeType}
                        selectedReturnProducts={selectedReturnProducts}
                        onSelectReturnProduct={handleSelectReturnProduct}
                        handleModelCofirmation={(row, shipmentIndex) => {
                          // Handle model confirmation for existing shipments
                        }}
                      />
                    )
                  })}
                </div>
              </div>
            )}

            {shipment.length ? (
              <div className="shipment-title-wrapper">
                <div className="shipment-title mb-3"></div>

                {/* <!-- Working --> */}
                <div className="shipment-box-wrapper">
                  {shipment.length
                    ? shipment?.map((item, index) => {
                      if (Boolean(item)) {
                        return (
                          <ShipmentTable
                            key={index}
                            shipment={shipment[index]} //
                            shipmentIndex={index}
                            shipmentValue={shipmentIds[index] ?? item}
                            hasLiveShipmentId={
                              shipmentIds[index] ? true : false
                            }
                            shipmentDeliveryPartner={
                              shipmentDeliveryPartners[index]
                            }
                            setShipment={setShipment}
                            columns={shipmentColumns}
                            data={shipmentData || []} //
                            selectedId={selectedId}
                            orderData={orderData?.items}
                            setOrderData={setOrderData}
                            setSelectedId={setSelectedId}
                            paylodArray={paylodArray}
                            setConfirmShipmentIds={setConfirmShipmentIds}
                            setFinalShipmentPayloadData={
                              setFinalShipmentPayloadData
                            }
                            // oldPayloadArray={oldPayloadArray[index]} // added new dm
                            oldPayloadArray={oldPayloadArray} // added new dm
                            setPlayloadArray={setPlayloadArray}
                            getModelConfirmation={
                              handleToggleShipmentConfirmModel
                            }
                            isDelete={isDelete}
                            handleDelete={handleDelete}
                            getModelStatus={getModelStatus}
                            isAllowHideSection={
                              shipmentIds[index] ? true : false
                            }
                            onPrintLabelClick={handleTogglePdfModel}
                            isPrintLabelLoading={printLabelLoader}
                            isShowPrintLabel={
                              shipmentDeliveryPartners[index] === "Logique" ||
                              shipmentDeliveryPartners[index] === "Maxpakket" ||
                              shipmentDeliveryPartners[index] === "DPD" ||
                              shipmentDeliveryPartners[index] === "PostNL" ||
                              shipmentDeliveryPartners[index] === "DPD Pickup"
                            }
                            getPackageModel={handleTogglePackagDetailModel}
                            getActiveShipmentDetail={setShipmentDetailData}
                            // isLockRecord={isLockRecord}
                            isLockRecord={
                              confirmShipmentIds[index] ? true : false
                            }
                            service_point_id={orderData?.service_point_id}
                          />
                        )
                      }
                    })
                    : null}
                </div>
              </div>
            ) : null}

            {dropship.length ? (
              <div className="shipment-title-wrapper">
                <div className="shipment-title mb-3"></div>

                {/* <!-- Working --> */}
                <div className="shipment-box-wrapper">
                  {dropship.length
                    ? dropship?.map((item, index) => {
                      if (Boolean(item)) {
                        return (
                          <DropshipTable
                            onCancelClick={handleDropshipTableOnCancelClick}
                            key={index}
                            selectedDropshipProductId={
                              selectedDropshipProductId
                            }
                            setIsDropshipAddedProduct={
                              setIsDropshipAddedProduct
                            }
                            orderData={orderData}
                            clearSelectedDropshipProductId={
                              clearSelectedDropshipProductId
                            }
                            dropshipData={dropshipData}
                            setDropshipData={setDropshipData}
                          />
                        )
                      }
                    })
                    : null}
                </div>
              </div>
            ) : null}

            {orderData?.items?.length > 0 && (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "16px",
                  }}
                >
                  {!isDropshipAddedProduct && <h5>Order Information</h5>}

                  {!isDropship && (
                    <div>
                      <button
                        className="btn btn-primary waves-effect waves-light btn btn-primary me-2"
                        onClick={shipmentHandle}
                      >
                        + Add Shipment
                      </button>

                      {shipment.length === 0 && (
                        <>
                          <button
                            className="btn btn-primary waves-effect waves-light btn btn-primary"
                            onClick={dropshipHandle}
                          >
                            + Add Dropship
                          </button>
                        </>
                      )}
                    </div>
                  )}
                </div>

                {!isDropship && (
                  <div>
                    <PaginatedTable
                      columns={columns}
                      data={orderData?.items || []}
                      isLoading={loading}
                      showCheckbox={true}
                      selectedProducts={selectedProducts}
                      selectedIds={selectedId} //
                    />
                    <button
                      onClick={sendEmailHandle}
                      className="btn btn-primary waves-effect waves-light btn btn-primary"
                    >
                      Send Email
                    </button>
                  </div>
                )}

                {isDropship && (
                  <div>
                    <DropshipSelectionTable
                      columns={dropshipColumns}
                      data={orderData?.items || []}
                      order_id={orderId}
                      selectedDropshipProductId={selectedDropshipProductId}
                      selectedDropshipProducts={handleSelectedDropshipProducts}
                      checkedArrayDropshipSelection={
                        checkedArrayDropshipSelection
                      }
                      setCheckedArrayDropshipSelection={
                        setCheckedArrayDropshipSelection
                      }
                      dropshipData={dropshipData}
                      setDropshipData={setDropshipData}
                      dropshippedData={orderData?.dropships}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      <ConfirmationDialog
        show={showShipmentConfirmModel}
        tittle={"Confirmation Dialogue"}
        description={"Are you sure to remove this product ?"}
        onCloseClick={handleToggleShipmentConfirmModel}
        onConfirmClick={onConfirmClick}
      />

      <PrintLabelModel
        show={showPdfModel}
        pdfBlob={labelBlob ? labelBlob : null}
        tittle={`Print Label For Shipment #${printLabelShipmentId}`}
        onCloseClick={() => setShowPdfModel(false)}
      />
      {renderShipmentConfirmation()}
    </div>
  )
}

export default OrderProcessing
